module.exports = __webpack_public_path__ + "img/Autocolant TME-01.c18ff65e.jpg";